import { createFormContext } from '@mantine/form';

import {
  MeterCoreFormType,
  SamplePlanFormV2Type,
  SoilHealthFormType,
  ThirtyCmCoreFormType,
  WetAggregateStabilityFormType,
} from 'store/projects/types';

export const [SamplePlanFormProvider, useSamplePlanFormContext, useSamplePlanForm] =
  createFormContext<SamplePlanFormV2Type, (values: SamplePlanFormV2Type) => SamplePlanFormV2Type>();

export const [MeterCoreFormProvider, useMeterCoreFormContext, useMeterCoreForm] = createFormContext<
  MeterCoreFormType,
  (values: MeterCoreFormType) => MeterCoreFormType
>();

export const [ThirtyCmCoreFormProvider, useThirtyCmCoreFormContext, useThirtyCmCoreForm] =
  createFormContext<ThirtyCmCoreFormType, (values: ThirtyCmCoreFormType) => ThirtyCmCoreFormType>();

export const [SoilHealthFormProvider, useSoilHealthFormContext, useSoilHealthForm] =
  createFormContext<SoilHealthFormType, (values: SoilHealthFormType) => SoilHealthFormType>();

export const [
  WetAggregateStabilityFormProvider,
  useWetAggregateStabilityFormContext,
  useWetAggregateStabilityForm,
] = createFormContext<
  WetAggregateStabilityFormType,
  (values: WetAggregateStabilityFormType) => WetAggregateStabilityFormType
>();
